import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const deleteAppUserRequest = (state: Draft<IAppUserState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const deleteAppUserSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{
  id: string
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  const newEntries = { ...state.entries };
  if (payload.id in newEntries) {
    delete newEntries[payload.id];
  }
  state.entries = newEntries;
};

export const deleteAppUserFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
